import React from 'react';
import { ExternalLinkIcon } from "@navikt/aksel-icons";

const NyFaneIkon = () => <ExternalLinkIcon title="Ekstern lenke. Åpnes i ny fane" aria-hidden="true" />

export default NyFaneIkon;



